import * as React from 'react';

import { AnimationElement } from '../../../../../../../common/Animation';

import { hintAnimationConfig } from './constants';
import * as styles from './RecommendedPackageHint.css';

export interface IProps {
  isMobile: boolean;
  text: string;
}

export const RecommendedPackageHint = ({ isMobile, text }: IProps) => {
  const [isRender, setRender] = React.useState(true);

  if (!isRender || isMobile) {
    return null;
  }

  return (
    <div className={styles['tooltip']}>
      <AnimationElement {...hintAnimationConfig}>
        <div className={styles['content']}>
          <div>{text}</div>

          <div data-testid="closeHint" className={styles['close']} onClick={() => setRender(false)}>
            &#x2715;
          </div>
        </div>
      </AnimationElement>
    </div>
  );
};
